var _circle, _circle2, _circle3, _circle4, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _g3, _circle5, _path21, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessionTimeout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 260,
    viewBox: "0 0 260 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.728,
    cy: 130.228,
    r: 115.228,
    fill: "url(#paint0_linear_2109_7255)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 226.397,
    cy: 93.8966,
    r: 4.89658,
    stroke: "#FF8A00",
    strokeWidth: 4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.181,
    cy: 74.3509,
    r: 9.55404,
    fill: "url(#paint1_linear_2109_7255)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 158.961,
    cy: 222.818,
    r: 4.89658,
    stroke: "#FF8A00",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2109_7255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.3375 138.336L44.2924 143.619L49.5754 145.574L44.2924 147.529L42.3375 152.812L40.3826 147.529L35.0996 145.574L40.3826 143.619L42.3375 138.336Z",
    fill: "#FF8A00"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.352 175.827C224.996 174.086 227.459 174.086 228.103 175.827L228.814 177.748C229.017 178.296 229.448 178.727 229.996 178.93L231.917 179.641C233.658 180.285 233.658 182.748 231.917 183.392L229.996 184.103C229.448 184.306 229.017 184.737 228.814 185.285L228.103 187.206C227.459 188.947 224.996 188.947 224.352 187.206L223.641 185.285C223.438 184.737 223.007 184.306 222.459 184.103L220.538 183.392C218.797 182.748 218.797 180.285 220.538 179.641L222.459 178.93C223.007 178.727 223.438 178.296 223.641 177.748L224.352 175.827Z",
    fill: "#FF8A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5899 26.069C100.234 24.3278 102.697 24.3278 103.341 26.069L104.648 29.6012C104.851 30.1486 105.283 30.5803 105.83 30.7828L109.362 32.0899C111.103 32.7342 111.103 35.197 109.362 35.8413L105.83 37.1483C105.283 37.3509 104.851 37.7825 104.648 38.3299L103.341 41.8621C102.697 43.6034 100.234 43.6034 99.5899 41.8621L98.2828 38.3299C98.0803 37.7825 97.6486 37.3509 97.1012 37.1483L93.569 35.8413C91.8278 35.197 91.8278 32.7342 93.569 32.0899L97.1012 30.7828C97.6486 30.5803 98.0803 30.1486 98.2828 29.6012L99.5899 26.069Z",
    fill: "#FF8A00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4121 208.185C18.7898 211.948 27.5718 217.739 35.6783 210.79C45.8113 202.105 53.6283 205.579 58.8396 210.79C64.0509 216.002 71.2888 219.476 79.9743 210.79",
    stroke: "#FF8A00",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.5 136.763C199.802 139.235 205.788 143.037 211.314 138.474C218.221 132.77 223.549 135.052 227.101 138.474C230.653 141.896 235.586 144.178 241.506 138.474",
    stroke: "#FF8A00",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.695 215.782C128.988 221.487 148.904 216.203 152.179 203.98C155.454 191.757 140.848 177.223 119.555 171.518C98.2629 165.813 78.3469 171.096 75.0717 183.319C71.7966 195.542 86.4025 210.076 107.695 215.782Z",
    fill: "url(#paint2_linear_2109_7255)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M152.184 203.975C148.908 216.199 128.989 221.508 107.693 215.802C86.3969 210.095 71.7948 195.537 75.0703 183.312L73.413 189.498C70.1392 201.716 84.7418 216.247 106.032 221.952C127.322 227.656 147.24 222.375 150.514 210.157L152.171 203.972L152.184 203.975Z",
    fill: "url(#paint3_linear_2109_7255)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.823 95.8949C120.053 90.5974 106.311 77.5383 109.191 66.7889C112.071 56.0395 130.5 51.6071 150.271 56.9046C170.041 62.2021 183.791 75.2567 180.911 86.0061C178.031 96.7555 159.6 101.194 139.823 95.8949ZM150.091 57.5757C130.688 52.3766 112.636 56.5911 109.856 66.967C107.076 77.3429 120.6 90.0248 140.003 95.2239C159.406 100.423 177.463 96.1895 180.24 85.8263C183.017 75.463 169.501 62.7765 150.091 57.5757Z",
    fill: "#BA68C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.817 203.077L148.818 203.07L149.489 203.25L148.817 203.077Z",
    fill: "#BA68C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7698 184.038L77.7715 184.031L78.4425 184.211L77.7698 184.038Z",
    fill: "#BA68C8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_2109_7255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.403 213.144C88.6322 207.847 74.8886 194.794 77.7689 184.045C80.6492 173.295 99.0779 168.863 118.848 174.16C138.619 179.458 152.369 192.513 149.489 203.262C146.608 214.011 128.18 218.444 108.403 213.144ZM118.669 174.832C99.2653 169.632 81.2155 173.841 78.4336 184.223C75.6517 194.605 89.1792 207.274 108.583 212.473C127.986 217.673 146.037 213.458 148.817 203.082C151.598 192.706 138.078 180.032 118.669 174.832Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.489 203.262L148.817 203.082C151.599 192.7 138.078 180.032 118.669 174.832C99.2589 169.631 81.2155 173.841 78.4336 184.223L77.8006 184.053L83.3016 163.523C84.7863 157.911 87.7642 152.807 91.9187 148.753C96.0731 144.699 101.249 141.846 106.895 140.499L118.102 137.85C119.101 137.61 120.017 137.105 120.753 136.388C121.489 135.671 122.018 134.769 122.284 133.776C122.55 132.784 122.543 131.738 122.264 130.749C121.985 129.76 121.444 128.865 120.699 128.158L112.318 120.26C108.099 116.277 105.038 111.225 103.46 105.641C101.882 100.057 101.847 94.1497 103.357 88.5473L108.955 67.6563L109.664 67.8462L109.584 68.1438C108.063 78.3548 121.405 90.2483 139.966 95.2218C158.527 100.195 176.035 96.5679 179.823 86.9641L179.934 86.675L180.643 86.865L175.045 107.756C173.559 113.367 170.58 118.47 166.425 122.523C162.269 126.575 157.093 129.426 151.447 130.772L140.234 133.419C139.237 133.661 138.322 134.167 137.588 134.884C136.853 135.601 136.325 136.503 136.059 137.495C135.794 138.486 135.8 139.531 136.078 140.52C136.355 141.508 136.894 142.403 137.637 143.112L146.024 151.011C154.391 159.516 157.812 171.668 154.951 182.749L149.489 203.262ZM118.848 174.16C136.258 178.825 148.99 189.497 149.827 199.315L154.319 182.552C157.121 171.714 153.769 159.81 145.576 151.495L137.2 143.605C136.365 142.811 135.759 141.806 135.447 140.697C135.135 139.587 135.127 138.414 135.426 137.301C135.724 136.188 136.317 135.176 137.142 134.371C137.967 133.567 138.994 132.999 140.114 132.729L151.327 130.081C156.847 128.766 161.908 125.98 165.971 122.019C170.035 118.057 172.95 113.07 174.406 107.585L179.223 89.6058C173.581 97.7491 157.133 100.561 139.813 95.9204C122.492 91.2793 109.661 80.6217 108.84 70.7465L104.022 88.7254C102.536 94.2074 102.564 99.9896 104.103 105.457C105.641 110.924 108.633 115.872 112.76 119.775L121.147 127.674C121.982 128.468 122.588 129.473 122.9 130.582C123.212 131.692 123.22 132.865 122.921 133.978C122.623 135.091 122.03 136.103 121.205 136.908C120.38 137.713 119.353 138.28 118.233 138.55L107.02 141.198C101.495 142.513 96.4291 145.302 92.3628 149.268C88.2964 153.233 85.3814 158.227 83.9279 163.718L79.4429 180.456C85.0764 172.371 101.446 169.497 118.848 174.16Z",
    fill: "#EBEBEB"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M126.082 159.242C125.304 158.47 124.339 157.914 123.28 157.631C122.222 157.347 121.108 157.345 120.049 157.625C110.849 160.052 86.3881 167.17 84.3169 174.9C81.7606 184.44 94.0266 196.018 111.721 200.759C129.415 205.5 145.833 201.608 148.389 192.068C150.46 184.338 132.835 165.943 126.082 159.242Z",
    fill: "url(#paint4_linear_2109_7255)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.082 159.242C125.304 158.47 124.339 157.914 123.28 157.631C122.222 157.347 121.108 157.345 120.049 157.625C110.849 160.052 86.3881 167.17 84.3169 174.9C81.7606 184.44 94.0266 196.018 111.721 200.759C129.415 205.5 145.833 201.608 148.389 192.068C150.46 184.338 132.835 165.943 126.082 159.242Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.722 200.766C94.0281 196.025 81.7621 184.446 84.3184 174.906L81.9724 183.662C79.4161 193.202 91.6884 204.782 109.376 209.521C127.064 214.26 143.488 210.37 146.045 200.83L148.391 192.074C145.834 201.615 129.416 205.507 111.722 200.766Z",
    fill: "url(#paint5_linear_2109_7255)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126.387 151.787C126.462 151.502 126.451 151.202 126.355 150.924C126.26 150.646 126.084 150.403 125.85 150.225C125.616 150.047 125.335 149.942 125.042 149.923C124.748 149.905 124.456 149.974 124.202 150.121C123.948 150.269 123.743 150.488 123.613 150.752C123.483 151.016 123.435 151.312 123.474 151.604C123.512 151.895 123.637 152.169 123.83 152.39C124.024 152.611 124.279 152.769 124.563 152.845C124.945 152.944 125.351 152.888 125.692 152.69C126.034 152.492 126.283 152.168 126.387 151.787Z",
    fill: "#BA68C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.695 69L107.607 87.9919C106.256 92.9905 106.283 98.2616 107.685 103.246C109.087 108.231 111.813 112.742 115.572 116.303L123.161 123.432C123.274 123.544 123.386 123.656 123.484 123.77C123.747 124.057 124.011 124.339 124.291 124.61C125.799 126.23 126.87 128.206 127.403 130.354C127.937 132.502 127.914 134.75 127.338 136.887L125.133 145.117C125.029 145.498 125.081 145.905 125.276 146.249C125.471 146.592 125.795 146.844 126.175 146.95C126.559 147.049 126.965 146.993 127.307 146.793C127.649 146.594 127.899 146.268 128.001 145.885L130.206 137.656C130.776 135.518 131.879 133.56 133.414 131.966C134.948 130.373 136.863 129.196 138.978 128.546C139.356 128.45 139.712 128.336 140.102 128.223C140.245 128.173 140.398 128.132 140.551 128.092L150.656 125.704C155.692 124.5 160.309 121.955 164.015 118.34C167.722 114.724 170.381 110.173 171.71 105.168L176.799 86.1766L112.695 69Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M115.568 116.305C115.568 116.305 121.088 123.687 115.569 116.308C115.569 116.308 115.574 116.309 115.569 116.305L123.158 123.434C123.271 123.546 123.384 123.657 123.482 123.772C123.744 124.059 124.008 124.34 124.288 124.612C125.796 126.231 126.868 128.208 127.401 130.356C127.934 132.504 127.912 134.752 127.336 136.889L125.131 145.119C125.027 145.5 125.078 145.907 125.273 146.25C125.469 146.594 125.792 146.846 126.173 146.952C126.556 147.051 126.963 146.994 127.305 146.795C127.647 146.596 127.896 146.269 127.998 145.887L130.204 137.657C130.773 135.519 131.877 133.562 133.411 131.968C134.946 130.374 136.86 129.197 138.975 128.547C139.353 128.452 139.71 128.337 140.1 128.225C140.242 128.174 140.395 128.134 140.549 128.094L150.654 125.706L115.568 116.305Z",
    fill: "url(#paint6_linear_2109_7255)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M126.387 151.787C126.462 151.502 126.451 151.202 126.355 150.924C126.26 150.646 126.084 150.403 125.85 150.225C125.616 150.047 125.335 149.942 125.042 149.923C124.748 149.905 124.456 149.974 124.202 150.121C123.948 150.269 123.743 150.488 123.613 150.752C123.483 151.016 123.435 151.312 123.474 151.604C123.512 151.895 123.637 152.169 123.83 152.39C124.024 152.611 124.279 152.769 124.563 152.845C124.945 152.944 125.351 152.888 125.692 152.69C126.034 152.492 126.283 152.168 126.387 151.787Z",
    fill: "url(#paint7_linear_2109_7255)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M140.095 94.8718C157.79 99.6131 174.207 95.7219 176.764 86.1804C179.32 76.639 167.049 65.0606 149.354 60.3193C131.659 55.578 115.242 59.4692 112.685 69.0106C110.129 78.5521 122.401 90.1305 140.095 94.8718Z",
    fill: "#BA68C8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M125.171 140.054L117.528 143.658C109.769 147.293 103.079 156.662 100.041 168L90.3622 204.122C88.6046 202.942 86.9368 201.633 85.3726 200.207L94.407 166.49C97.445 155.152 104.736 145.944 113.382 142.547L121.917 139.182C125.474 137.781 127.055 131.881 124.671 128.901L118.962 121.72C113.199 114.462 111.465 102.829 114.494 91.5228L120.004 70.9609L125.638 72.4706L120.129 93.0325C117.091 104.371 118.23 115.844 123.101 122.862L127.917 129.805C129.929 132.651 128.348 138.551 125.171 140.054Z",
    fill: "white"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.117 98.516C160.409 104.221 180.325 98.9376 183.601 86.7145C186.876 74.4914 172.27 59.9576 150.977 54.2523C129.685 48.5469 109.769 53.8306 106.494 66.0537C103.218 78.2768 117.824 92.8106 139.117 98.516Z",
    fill: "url(#paint8_linear_2109_7255)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M183.602 86.7249C180.326 98.9494 160.407 104.258 139.111 98.5517C117.815 92.8454 103.213 78.2869 106.488 66.0625L104.831 72.2475C101.555 84.4719 116.151 99.0288 137.441 104.733C158.731 110.438 178.649 105.156 181.932 92.9066L183.589 86.7216L183.602 86.7249Z",
    fill: "url(#paint9_linear_2109_7255)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2109_7255)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 200.329,
    cy: 57.9931,
    r: 25.829,
    fill: "#FF4F75"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.329,
    cy: 52.829,
    r: 25.829,
    fill: "#FF4F75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M198.451 56.9429L197.488 44.2708L197.302 38.75H203.416L203.231 44.2708L202.267 56.9429H198.451ZM200.378 66.8359C198.451 66.8359 197.08 65.465 197.08 63.5382C197.08 61.6115 198.488 60.2776 200.378 60.2776C202.23 60.2776 203.638 61.6115 203.638 63.5382C203.638 65.465 202.23 66.8359 200.378 66.8359Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2109_7255",
    x: 31.0996,
    y: 134.336,
    width: 22.4766,
    height: 22.4766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2109_7255"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_2109_7255",
    x: 69.3867,
    y: 63.6562,
    width: 119.256,
    height: 163.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2109_7255"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2109_7255",
    result: "effect2_dropShadow_2109_7255"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2109_7255",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2109_7255",
    x: 144.5,
    y: 2.16406,
    width: 111.658,
    height: 111.656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_2109_7255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2109_7255",
    x1: 125.728,
    y1: 15,
    x2: 125.728,
    y2: 245.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302083,
    stopColor: "#FFE8CC",
    stopOpacity: 0.776316
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD70"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2109_7255",
    x1: 52.181,
    y1: 64.7969,
    x2: 52.181,
    y2: 83.905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FF8A00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2109_7255",
    x1: 119.555,
    y1: 171.518,
    x2: 107.695,
    y2: 215.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2109_7255",
    x1: 113.627,
    y1: 193.644,
    x2: 106.041,
    y2: 221.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2109_7255",
    x1: 123.28,
    y1: 157.631,
    x2: 111.724,
    y2: 200.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C02C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2109_7255",
    x1: 116.354,
    y1: 183.49,
    x2: 109.379,
    y2: 209.522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C02C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2109_7255",
    x1: 133.111,
    y1: 121.005,
    x2: 126.16,
    y2: 146.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C02C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2109_7255",
    x1: 125.334,
    y1: 149.971,
    x2: 124.563,
    y2: 152.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD155"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2109_7255",
    x1: 150.977,
    y1: 54.2523,
    x2: 139.117,
    y2: 98.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2109_7255",
    x1: 145.045,
    y1: 76.3937,
    x2: 137.451,
    y2: 104.736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionTimeout);
export default __webpack_public_path__ + "static/media/session-timeout.59fe13cbdcf2acdd64250f624e186d54.svg";
export { ForwardRef as ReactComponent };